import { render, staticRenderFns } from "./OnboardingInstallationNoTypeModal.vue?vue&type=template&id=33997a22&scoped=true"
import script from "./OnboardingInstallationNoTypeModal.vue?vue&type=script&lang=js"
export * from "./OnboardingInstallationNoTypeModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingInstallationNoTypeModal.vue?vue&type=style&index=0&id=33997a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33997a22",
  null
  
)

export default component.exports